import WhatsAppIcon from "@/assets/wicon.png";

const WhatsAppFloat: React.FC = () => {
	return (
		<a
			href="https://wa.me/+491703571907"
			target="_blank"
			rel="noopener noreferrer"
			className="whatsapp-float"
			aria-label="WhatsApp Kontakt"
		>
			<div className="relative group">
				<img
					src={WhatsAppIcon}
					alt="WhatsApp"
					width="60"
					height="60"
					className="w-[60px] h-[60px] transition-transform duration-300 group-hover:scale-110 drop-shadow-lg"
				/>
				{/* Pulse animation ring */}
				<span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20" />
			</div>
		</a>
	);
};

export default WhatsAppFloat;
